
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacypolicy.html",
      function () {
        return require("private-next-pages/privacypolicy.html.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacypolicy.html"])
      });
    }
  